<app-page-breadcrumb pageTitle="Line Chart" />
<div class="space-y-6">
  <div>
    <app-component-card title="Line Chart 1">
      <app-line-chart-one/>
    </app-component-card>
  </div>
</div>